module.exports = "/_next/static/images/ScoreMeter0@2x-b02b55469dd709a142a86e4e66d190cb.png";